import React from "react";
import { ArrowUpRight, Target, Globe, PlayCircle, Sparkles, ShoppingBag, Radio } from "lucide-react";
import { operatingSystem } from "../mock";

const ICONS = { Target, Globe, PlayCircle, Sparkles, ShoppingBag, Radio };

export default function OperatingSystem() {
  return (
    <section id="whatwedo" className="relative overflow-hidden bg-[var(--crtr-beige)]">
      <div className="mx-auto flex max-w-[1500px] flex-col px-5 py-20 md:flex-row md:px-10 md:py-24">
        <div className="relative mb-10 flex items-start md:mb-0 md:w-[16%]">
          <h2 className="font-heavy text-3xl uppercase text-black md:vertical-title md:text-2xl md:tracking-wide">
            Our Operating System
          </h2>
        </div>

        <div className="grid flex-1 grid-cols-1 gap-px overflow-hidden rounded-xl bg-black/15 sm:grid-cols-2 lg:grid-cols-3">
          {operatingSystem.items.map((it) => {
            const Icon = ICONS[it.icon];
            return (
              <div key={it.num} className="group relative bg-[var(--crtr-cream)] p-7 transition-colors duration-300 hover:bg-[var(--crtr-yellow)]">
                <div className="flex items-center justify-between">
                  <span className="mono-label text-xs text-black/50">{it.num}</span>
                  <ArrowUpRight className="h-5 w-5 text-black/50 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
                <Icon className="mt-10 h-9 w-9 text-black" strokeWidth={1.6} />
                <h3 className="font-heavy mt-5 text-2xl uppercase text-black">{it.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-black/70">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
